'use strict';

require('../CompanyAddressBookService.js');
require('./CompanyPublicationShareService.js');
require('../customers/CompanyCustomersService.js');
require('./companyOrder/CompanyPublicationCompanyOrderService.js');
require('./companyOrderSubcription/CompanyPublicationCompanyOrderSubcriptionService.js');
require('./order/CompanyPublicationOrderService.js');

CompanyPublicationShareAccessCtrl.$inject = [
  '$scope',
  '$state',
  '$stateParams',
  'config',
  '$window',
  'lastFile',
  'publication',
  'shares',
  'groups',
  'customerPortals',
  'children',
  'growl',
  '$q',
  'CompanyGroupService',
  'CompanyPublicationShareService',
  'CompanyAddressBookService',
  'CompanyCustomersService',
  'CompanyPublicationCompanyOrderService',
  'CompanyPublicationCompanyOrderSubcriptionService',
  'CompanyPublicationOrderService',
  'translations'];
function CompanyPublicationShareAccessCtrl(
  $scope,
  $state,
  $stateParams,
  config,
  $window,
  lastFile,
  publication,
  shares,
  groups,
  customerPortals,
  children,
  growl,
  $q,
  CompanyGroupService,
  CompanyPublicationShareService,
  CompanyAddressBookService,
  customersService,
  publicationCompanyOrderService,
  publicationCompanyOrderSubcriptionService,
  orderService,
  translations) {
  $scope.publication = publication;
  $scope.shares = shares;
  $scope.lastFile = lastFile;
  $scope.customerPortals = customerPortals;
  $scope.groups = groups;
  $scope.children    = children.slice(0, 20);
  $scope.hasMore     = children.length > 20;
  $scope.currentPage = $stateParams.page|0;
  $scope.tabActive = 4;

  for(var i = 0; i < $scope.groups.length; i++) {
    /* All groups are HIDDEN already */
    if($scope.publication.groups.indexOf($scope.groups[i].id) !== -1) {
      $scope.selectedGroup = $scope.groups[i];
      break;
    }
  }
      
  function openAdditionalOptions() {
    $scope.additionalOptionsOpen = true;
  }
  
  function closeAdditionalOptions() {
    $scope.additionalOptionsOpen = false;
  }
  
  function toggleAdditionalOptions() {
    if($scope.additionalOptionsOpen) {
      closeAdditionalOptions();
    }
    else {
      openAdditionalOptions();
    }
  }

  $scope.toggleAdditionalOptions = toggleAdditionalOptions;
  $scope.closeAdditionalOptions = closeAdditionalOptions;

  // Customer portals
  $scope.toggleCustomerPortal = function(customerPortalId) {
    var i = $scope.publication.groups.indexOf(customerPortalId);
    if(-1 !== i) {
      $scope.publication.groups.splice(i, 1);
    } else {
      $scope.publication.groups.push(customerPortalId);
    }
  };

  $scope.setGroup = function(group) {
    for(var i = 0; i < $scope.groups.length; i++) {
      var idx = $scope.publication.groups.indexOf($scope.groups[i].id);
      
      if(idx !== -1) {
        $scope.publication.groups.splice(idx, 1);
      }
    }
    
    if(group) {
      $scope.publication.groups.push(group.id);
    }
    
    return $scope.savePublication($scope.publication).then(function() {
      $scope.selectedGroup = group;
    });
  };

  $scope.searchPortals = function(togglePortals, filterPortals) {
    var filter = {
      companyId: $stateParams.companyId, 
      userId: $window.localStorage.userId, 
      type: 'VISIBLE', 
      q: filterPortals,
      all: true
    };
    if(togglePortals === 1){
      filter.customerConnected = false;
    }
    if(togglePortals === 2){
      filter.customerConnected = true;
    }
    CompanyGroupService.query(filter).$promise.then(function(portals){
      $scope.customerPortals = portals;
    });
  };

  function checkExpiredShare() {
    var today = new Date();
    angular.forEach($scope.shares, function(v){
      v.expired = false;
      if ((new Date(v.deadline) < today) && v.deadline !==  null) {
        v.expired = true;
      }
    });
  }

  checkExpiredShare();

  $scope.shareFormCollapse = true;
  if(publication.status === 'ARCHIVED'){
    $scope.shareFormCollapse = false;
  }
  $scope.newShare = new CompanyPublicationShareService();
  $scope.newShare.features = {};
  if ($scope.publication.type === 'DEFAULT' || $scope.publication.type === 'ALBUM') {
    $scope.newShare.features.type = 'normal';
  }
  $scope.newShare.email = '';

  $scope.newCreateShare = new CompanyPublicationShareService();
  $scope.newCreateShare.features = {};
  $scope.newCreateShare.subject = translations['publication.share.default-subject'];
  if ($scope.publication.type === 'DEFAULT' || $scope.publication.type === 'ALBUM') {
    $scope.newCreateShare.features.type = 'normal';
  }
  $scope.newCreateShare.email = $scope.currentUser.email;

  $scope.shareURLBase  = config.shareURLBase;
  $scope.apiBase  = config.apiBase;

  $scope.supported = false;

  CompanyAddressBookService.query({companyId: $stateParams.companyId}).$promise.then(function(c) {
    $scope.allContacts = angular.copy(c);
    $scope.contacts    = angular.copy(c);
    $scope.newContacts = [];
  });

  function saveShare(share, hasSendEmail) {
    CompanyPublicationShareService.save({companyId: $stateParams.companyId, publicationId: $stateParams.publicationId}, share, function(data) {
      share.visits = 0;
      share.createdAt = new Date();
      share.id = data.id;
      share.secretKey = data.secret;
      $scope.shares.push(share);
      growl.addSuccessMessage('Created share: ' + share.email + ' successfully!');
      if(hasSendEmail){
        if($scope.publication.type === 'FORM'){
          $scope.publication.features.viewerLink = config.shareURLBase + 'forms/' + data.id + '?token=' + data.secret;
        }else{
          $scope.publication.features.viewerLink = config.shareURLBase + data.id + '?token=' + data.secret;
        }
        $scope.newShare = new CompanyPublicationShareService();
        $scope.newShare.features = {};
        if ($scope.publication.type === 'DEFAULT' || $scope.publication.type === 'ALBUM') {
          $scope.newShare.features.type = 'normal';
        }  
        $scope.newShare.email = '';
      }else{
        if($scope.publication.type === 'FORM'){
          $scope.publication.features.viewerLink = config.shareURLBase + 'forms/' + data.id + '?token=' + data.secret;
          $scope.haveShared = data;
        }else{
          $scope.publication.features.viewerLink = config.shareURLBase + data.id + '?token=' + data.secret;
          $scope.haveShared = data;
        }
        $scope.newCreateShare = new CompanyPublicationShareService();
        $scope.newCreateShare.features = {};
        if ($scope.publication.type === 'DEFAULT' || $scope.publication.type === 'ALBUM') {
          $scope.newCreateShare.features.type = 'normal';
        }  
        $scope.newCreateShare.email = $scope.currentUser.email;
      }
      $scope.savePublication($scope.publication);

    }, function() {
      growl.addErrorMessage('Could not create share: ' + share.email);
    });
  }

  $scope.addContact = function(contact, hasSendEmail) {
    $scope.contacts.splice($scope.contacts.indexOf(contact), 1);
    if(hasSendEmail){
      if (!$scope.newShare.email) {
        $scope.newShare.email = contact.contactEmail;
      }
      else {
        $scope.newShare.email += (', ' + contact.contactEmail);
      }
    }else{
      if (!$scope.newCreateShare.email) {
        $scope.newCreateShare.email = contact.contactEmail;
      }
      else {
        $scope.newCreateShare.email += (', ' + contact.contactEmail);
      }
    }

    $scope.suggestionsModalOpen = false;
  };


  function findNewAddresses(hasSendEmail) {
    var array = [];
    if(hasSendEmail){
      array = $scope.newShare.email.split(', ');
    }else{
      array = $scope.newCreateShare.email.split(', ');
    }

    for (var i = array.length - 1; i >= 0; i--) {
      for (var x = $scope.allContacts.length - 1; x >= 0; x--) {
        if ($scope.allContacts[x].contactEmail === array[i]) {
          array.splice(array[i], 1);
        }
      }
    }

    return array;
  }


  // Shares
  $scope.saveShare = function(hasSendEmail) {
    if(hasSendEmail){
      var i;
      var emails = $scope.newShare.email.split(',').map(function(item) {
        return item.trim();
      });

      for(i = 0; i < emails.length; i++) {
        var tmpShare = angular.copy($scope.newShare);
        tmpShare.email = emails[i];
        saveShare(tmpShare, hasSendEmail);
      }

      if ($scope.newShare.addToAddressBook) {
        var newAddresses = findNewAddresses(true);
        var contact;

        for (i = newAddresses.length - 1; i >= 0; i--) {
          contact = {
            contactName:  newAddresses[i],
            contactEmail: newAddresses[i]
          };

          CompanyAddressBookService.save({companyId: $stateParams.companyId}, contact).$promise.then(function() {
            $scope.contacts.push(contact);
          });
        }
      }
    }else{
      var i;
      var emails = $scope.newCreateShare.email.split(',').map(function(item) {
        return item.trim();
      });

      for(i = 0; i < emails.length; i++) {
        var tmpShare = angular.copy($scope.newCreateShare);
        tmpShare.email = emails[i];
        saveShare(tmpShare);
      }
      if ($scope.newCreateShare.addToAddressBook) {
        var newAddresses = findNewAddresses();
        var contact;

        for (i = newAddresses.length - 1; i >= 0; i--) {
          contact = {
            contactName:  newAddresses[i],
            contactEmail: newAddresses[i]
          };

          CompanyAddressBookService.save({companyId: $stateParams.companyId}, contact).$promise.then(function() {
            $scope.contacts.push(contact);
          });
        }
      }
    }

  };

  $scope.setNewDate = function(days, hasSendEmail) {
    var newDate = new Date();
    newDate.setDate(newDate.getDate() + days);

    if(hasSendEmail){
      $scope.newShare.deadline = newDate.toISOString();
    }else{
      $scope.newCreateShare.deadline = newDate.toISOString();
    }
  };

  // set default date
  $scope.setNewDate(14, true);
  $scope.setNewDate(14);


  $scope.deleteShareLink = function(share) {
    share.updating = true;
    CompanyPublicationShareService.delete({
      companyId: $scope.publication.companyId,
      publicationId: $scope.publication.id,
      shareId: share.id
    }, function(){
      angular.forEach($scope.shares, function(v){
        if (v.id === share.id) {
          v.deadline = new Date();
          v.expired = true;
        }
      });
      share.updating = false;
    }, function(){
      share.updating = false;
    });
  };

  $scope.sendEmail = function(share) {
    CompanyPublicationShareService.sendEmailAgain({
      companyId: $stateParams.companyId,
      publicationId: $stateParams.publicationId,
      shareId: share.id
    }, function(){
      growl.addSuccessMessage(translations['publication.share.send-email-success']);
    }, function(){
      growl.addErrorMessage(translations['publication.share.send-email-failure']);
    });
  };

  $scope.copySuccess = function() {
    growl.addSuccessMessage(translations['publication.share.share-link-copy-success']);
  };

  $scope.copyFail = function() {
    growl.addErrorMessage(translations['publication.share.share-link-copy-failure']);
  };

  $scope.queryCustomers = function(text) {
    return customersService.query({
      companyId: $stateParams.companyId,
      q:         text,
      limit:     10
    }).$promise.then(function(p) {
      return p.filter(function(p) {
        if (!$scope.order) {
          return true;
        }
        return ![$scope.order.customer].some(function(publication) {
          return publication.id === p.id;
        });
      });
    });
  };

  $scope.addCustomer = function(customer) {

    var customerDeferred = $q.defer();
    if ($scope.publication.features.currentCustomerId) {
      customersService.removeObject({
        companyId: $stateParams.companyId,
        objectId: $scope.publication.id,
        customerId: customer.id
      }, function(){
        customerDeferred.resolve();
      }, function(){
        customerDeferred.resolve();
      });
    } else {
      customerDeferred.resolve();
    }

    customerDeferred.promise.then(function(){
      customersService.addObject({
        companyId: $stateParams.companyId,
        customerId: customer.id
      }, {
        object: {
          id: publication.id,
          name: publication.name
        }
      }, function(){
        $scope.publication.features.currentCustomerId = customer.id;
        $scope.savePublication($scope.publication);
        customersService.get({
          companyId: $stateParams.companyId,
          publicationId: $scope.publication.id,
          customerId: customer.id
        }, function(resp){
          $scope.connectedCustomer = angular.copy(resp);
        });
      });
    });
    

    if (publication.type === 'COMPANY_ORDER' || publication.type === 'ORDER_SUBCRIPTION' || publication.type === 'ORDER') {
      var data = {
        customer: customer
      };

      if (publication.type === 'COMPANY_ORDER' || publication.type === 'ORDER_SUBCRIPTION') {
        data.publication = {
          name: $scope.publication.name,
          id: $scope.publication.id
        };
      } else {
        data.publicationId = $scope.publication.id;
      }

      if ($scope.order) {
        data = angular.copy($scope.order);
        data.customer = customer;
      }

      if (publication.type === 'COMPANY_ORDER' || publication.type === 'ORDER_SUBCRIPTION') {
        if ($scope.order) {
          data.status = $scope.order.status;
        } else {
          data.status = 'CART';
        }
        if(publication.type === 'COMPANY_ORDER'){
          publicationCompanyOrderService.update({
            companyId: $stateParams.companyId,
            publicationId: $stateParams.publicationId
          }, data).$promise.then(function(order){
            $scope.order = angular.copy(order);
            $scope.$broadcast('customerChanged');
            $scope.$broadcast('showCustomerInfo');
            $scope.publication.features.currentCompanyOrderId = $scope.order.id;
            $scope.savePublication($scope.publication);
          }).then(function(){
            growl.addSuccessMessage(translations['order.customer.add-success']);
          }, function(){
            growl.addErrorMessage(translations['order.customer.add-failure']);
          });
        }else{
          publicationCompanyOrderSubcriptionService.update({
            companyId: $stateParams.companyId,
            publicationId: $stateParams.publicationId
          }, data).$promise.then(function(order){
            $scope.order = angular.copy(order);
            $scope.$broadcast('customerChanged');
            $scope.$broadcast('showCustomerInfo');
            $scope.publication.features.currentCompanyOrderId = $scope.order.id;
            $scope.savePublication($scope.publication);
          }).then(function(){
            growl.addSuccessMessage(translations['order.customer.add-success']);
          }, function(){
            growl.addErrorMessage(translations['order.customer.add-failure']);
          });
        }
      } else if (publication.type === 'ORDER') {
        orderService.update({
          companyId: $stateParams.companyId,
          publicationId: $stateParams.publicationId
        }, data).$promise.then(function(order){
          $scope.order = angular.copy(order);
          $scope.publication.features.currentOrderId = $scope.order.id;
          $scope.savePublication($scope.publication);
        }).then(function() {
          growl.addSuccessMessage(translations['order.customer.add-success']);
        },
        function() {
          growl.addErrorMessage(translations['order.customer.add-failure']);
        });
      }
    }
  };

  $scope.connectedCustomer = false;
  if (publication.features.currentCustomerId) {
    $scope.connectedCustomer = customersService.get({
      companyId: $stateParams.companyId,
      publication: $stateParams.publicationId,
      customerId: publication.features.currentCustomerId
    }, function(resp){
      $scope.connectedCustomer = angular.copy(resp);
    });
  }
}

CompanyPublicationShareAccessCtrl.resolve = {
  shares: ['$stateParams', 'CompanyPublicationShareService', 'info', function($stateParams, CompanyPublicationShareService, info) {
    if(info.features.shareObject){
      return CompanyPublicationShareService.query({companyId: $stateParams.companyId, publicationId: $stateParams.publicationId, limit: 1000}).$promise;
    }
    return false;
  }],
  groups: ['CompanyGroupService', '$stateParams', '$window', function(CompanyGroupService, $stateParams, $window){
    return CompanyGroupService.query({
      companyId: $stateParams.companyId,
      userId: $window.localStorage.userId,
      all: true}).$promise;
  }],
  lastFile: ['$stateParams', 'CompanyPublicationFileService', function($stateParams, CompanyPublicationFileService) {
    return CompanyPublicationFileService.getLastFile({companyId: $stateParams.companyId, publicationId: $stateParams.publicationId}).$promise;
  }],
  children: ['$stateParams', 'CompanyPublicationService', 'company', function($stateParams, CompanyPublicationService) {
    return CompanyPublicationService.query({companyId: $stateParams.companyId, parentId: $stateParams.publicationId, limit: 21, offset: ($stateParams.page|0) * 20}).$promise;
  }],
  translations: ["$translate", function($translate){
    return $translate([
        'publication.share.default-subject',
        'publication.share.share-link-copy-success',
        'publication.share.share-link-copy-failure',
        'publication.share.send-email-success',
        'publication.share.send-email-failure',
        'order.customer.add-success',
        'order.customer.add-failure',
        "publication.share.default-subject"
      ]);
  }]
};

module.exports = CompanyPublicationShareAccessCtrl;

angular.module('dokiv')
  .controller('CompanyPublicationShareAccessCtrl', CompanyPublicationShareAccessCtrl);


//////////////////
// WEBPACK FOOTER
// ./scripts/company/publications/CompanyPublicationShareAccessCtrl.js
// module id = 380
// module chunks = 0